// =============================================================================
// SUPER ADMIN — Feedback (all tenants)
//
// Thin wrapper around the shared FeedbackPage. Fetches the tenant
// name index once so each feedback row can show "from <tenant>" tag.
// =============================================================================

import { useEffect, useState } from 'react';
import { FeedbackPage } from '@/pages/shared/FeedbackPage';
import { fetchTenants } from '@/lib/api';

export default function SuperAdminFeedbackPage() {
  const [tenantNameById, setTenantNameById] = useState<Record<string, string>>({});

  // Best-effort tenant name resolution — used only for the per-row
  // "from <tenant>" pill on the super-admin view. If the fetch fails
  // the page still renders correctly; rows just won't show a tenant
  // name pill.
  useEffect(() => {
    (async () => {
      try {
        const tenants = await fetchTenants();
        const map: Record<string, string> = {};
        for (const t of tenants) map[t.id] = t.name;
        setTenantNameById(map);
      } catch {
        /* silent fail — pill is decorative */
      }
    })();
  }, []);

  return <FeedbackPage tenantNameById={tenantNameById} />;
}
